export const SignIn = {
    Title: 'Sign in to curb-it',
    SubHeader: 'The easiest way to get rid of staff',
    Labels: {
        Login: 'LOGIN',
        Password: 'PASSWORD'
    },
    Links: {
        ForgotPassword: 'Forgot password?',
        CreateNewAccount: 'Create new account.'
    },
    Buttons: {
        SignIn: {
            label: 'Sign In'
        }
    },
    Errors: {
        Email: 'Invalid email.'
    }
}



// WEBPACK FOOTER //
// ./src/localization/SignIn.ts